import { api } from '../lib/api';

// Participants service: unified helpers to fetch names/avatars for bookings, chats, and users
const participantsService = {
  // Booking participants via canonical backend endpoint
  async getBookingParticipants(bookingId) {
    if (!bookingId) return { client: null, creative: null };
    const res = await api.get(`/bookings/${bookingId}/participants`);
    const d = res?.data || res;
    const payload = d?.data || d || {};
    const client = payload?.client || null;
    const creative = payload?.creative || null;
    return {
      client: client ? { name: client.name || '', avatar_url: client.avatar_url || '' } : null,
      creative: creative ? { name: creative.name || '', avatar_url: creative.avatar_url || '' } : null,
    };
  },

  // Generic participants resolution (booking_id OR client_id/creative_id)
  async getParticipants({ booking_id, client_id, creative_id } = {}) {
    const params = new URLSearchParams();
    if (booking_id) params.set('booking_id', String(booking_id));
    if (client_id) params.set('client_id', String(client_id));
    if (creative_id) params.set('creative_id', String(creative_id));
    const res = await api.get(`/participants?${params.toString()}`);
    const d = res?.data || res;
    const payload = d?.data || d || {};
    const client = payload?.client || null;
    const creative = payload?.creative || null;
    return {
      client: client ? { name: client.name || '', avatar_url: client.avatar_url || '' } : null,
      creative: creative ? { name: creative.name || '', avatar_url: creative.avatar_url || '' } : null,
    };
  },

  // Public-safe user info for one or more IDs
  async getPublicUsers(ids) {
    if (!ids) return [];
    const list = Array.isArray(ids) ? ids : [ids];
    const res = await api.get('/users/public', { params: { ids: list.join(',') } });
    const d = res?.data || res;
    const arr = d?.data?.users || d?.users || d?.data || [];
    return Array.isArray(arr) ? arr.map((u) => ({ id: u.id, name: u.name || '', avatar_url: u.avatar_url || '' })) : [];
  },
};

export default participantsService;
